module.exports = __webpack_public_path__ + "store/img/membership-core.0233f47a.svg";